import React, { useState } from "react";
import "../../style/Fournisseur.css";
import { useHistory } from "react-router-dom";
import axios from "axios";

import { useToasts } from "react-toast-notifications";

const API_URL = process.env.REACT_APP_API_URL;

function AdminAjoutFournisseur(props) {
  const [entite, setEntite] = useState(
    props.fournisseurId ? { fournisseur_verre_id: props.fournisseurId } : {}
  );
  const history = useHistory();
  const { addToast } = useToasts();

  const TOKEN_KEY = "jwt";
  const token = localStorage.getItem(TOKEN_KEY);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEntite((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  function submitForm(e) {
    e.preventDefault();
    axios
      .post(`${API_URL}/api/${props.category}`, entite, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .then(() => {
        addToast("Gloire au Créateur !", {
          appearance: "success",
          autoDismiss: true,
        });
        history.push("/backoffice/home");
      })
      .catch((e) => {
        console.error(e);
        addToast(`Erreur : ${e.message}`, {
          appearance: "error",
          autoDismiss: true,
        });
      });
  }

  return (
    <div className="fournisseurMain">
      <form onSubmit={submitForm}>
        Nom :{" "}
        <input
          type="text"
          value={entite.nom}
          name="nom"
          onChange={handleChange}
        />
        <br />
        {props.category !== "verriers/agence" && (
          <>
            Site internet :{" "}
            <input
              type="url"
              value={entite.site_internet}
              name="site_internet"
              onChange={handleChange}
            />
            <br />
          </>
        )}
        {props.category !== "verriers" && (
          <>
            Adresse 1 :{" "}
            <input
              type="text"
              value={entite.adresse_rue_1}
              name="adresse_rue_1"
              onChange={handleChange}
            />
            <br />
            Adresse 2 :{" "}
            <input
              type="text"
              value={entite.adresse_rue_2}
              name="adresse_rue_2"
              onChange={handleChange}
            />
            <br />
            Code Postal :{" "}
            <input
              type="text"
              value={entite.adresse_code_postal}
              name="adresse_code_postal"
              onChange={handleChange}
            />
            <br />
            Ville :{" "}
            <input
              type="text"
              value={entite.adresse_ville}
              name="adresse_ville"
              onChange={handleChange}
            />
            <br />
            Pays :{" "}
            <input
              type="text"
              value={entite.adresse_pays}
              name="adresse_pays"
              onChange={handleChange}
            />
            <br />
            Télephone :{" "}
            <input
              type="text"
              value={entite.telephone}
              name="telephone"
              onChange={handleChange}
            />
            <br />
            Fax :{" "}
            <input
              type="text"
              value={entite.fax}
              name="fax"
              onChange={handleChange}
            />
            <br />
            Adresse mail :{" "}
            <input
              type="email"
              value={entite.email}
              name="email"
              onChange={handleChange}
            />
            <br />
          </>
        )}
        {props.category === "verriers/agence" && (
          <>
            {" "}
            Télephone technique:{" "}
            <input
              type="text"
              value={entite.telephone_contact_technique}
              name="telephone"
              onChange={handleChange}
            />
            <br />
          </>
        )}
        <button type="submit">Enregistrer</button>
      </form>
    </div>
  );
}

export default AdminAjoutFournisseur;
